import React from 'react'

import Link from '@/components/Link'

export default function SettingsIgnored() {
  const ignoredUsers = []
  const handleClick = user => {
    // put user ignore list
  }
  return (
    <div>
      {ignoredUsers.length > 0 ? (
        <>
          <div className="px-4 justify-between flex mb-4">
            <p className="font-medium text-gray-300">Action</p>
            <p className="font-medium text-gray-300">User</p>
          </div>
          <div className="grid gap-2">
            {ignoredUsers.map((user, index) => <Item key={index} user={user} onClick={() => handleClick(user)} />)}
          </div>
        </>
      ) : (
        <div className="py-8 flex justify-center">
          <p className="text-gray-300">No ignored users to show</p>
        </div>
      )}
    </div>
  )
}

const Item = ({ onClick, user }) => {
  return (
    <div className="flex justify-between items-center bg-gray-800 rounded px-4 py-3 even:bg-gray-900">
      <button onClick={onClick} className="font-medium text-red-500">
        <span>Unignore</span>
      </button>
      <Link className="text-white font-medium" to={`?modal=user&name=${user}`}>{user}</Link>
    </div>
  )
}